import { ThisReceiver } from "@angular/compiler";
import { serverAccountInfoModel } from "./serverResponse.model";

export class postAuthorizeServiceResModel{
    error: boolean;
    code: string;
    message: string;

    constructor(error: boolean, code: string, message: string){
        this.error = error;
        this.code = code;
        this.message = message;
    }
}

export class postTokenServiceResModel{
    error: boolean;
    accessToken: string;
    message: string;

    constructor(error: boolean, accessToken: string, message: string){
        this.error = error;
        this.accessToken = accessToken;
        this.message = message;
    }
}

export class postOtpServiceResModel{
    error: boolean;
    refNo: string;
    message: string;

    constructor(error: boolean, refNo: string, message:string){
        this.error = error;
        this.refNo = refNo;
        this.message = message;
    }
}

export class getAccountInfoServiceResModel{
    error: boolean;
    message: string;
    accountInfo!: accountInfoModel;

    constructor(error: boolean, message: string, accountInfo: serverAccountInfoModel){
        this.error = error;
        this.message = message;
        if(error === false){
            this.accountInfo = new accountInfoModel(accountInfo);
        }
    }
}

export class accountInfoModel{
    userId: string;
    accountId: string;
    userName: string;
    email: string;
    phone: string;
    accountCreateDate: string;
    cCardNo: string;
    cCardExprMonth: string;
    cCardExprYear: string;
    countryCode: string;
    fileUrl: string;

    constructor(accountInfo: serverAccountInfoModel){
        this.userId = accountInfo.user_id.toString();
        this.accountId = accountInfo.accountId.toString();
        this.userName = accountInfo.name + ' ' + accountInfo.surname;
        this.phone = accountInfo.phone;
        this.email = accountInfo.email;
        this.accountCreateDate = accountInfo.accountCreateDate;
        this.cCardNo = accountInfo.cCardNo;
        this.cCardExprMonth = accountInfo.cCardExprMonth;
        this.cCardExprYear = accountInfo.cCardExprYear;
        this.countryCode = accountInfo.country_code;
        this.fileUrl = accountInfo.file_url;
    }
}

export class putChangePinServiceResModel{
    error: boolean;
    message: string;

    constructor(error: boolean, message: string){
        this.error = error;
        this.message = message;
    }
}

export class putAccountValidateServiceResModel{
    error: boolean;
    message: string;
    refNo: string;

    constructor(error: boolean, message: string, refNo: string){
        this.error = error;
        this.message = message;
        this.refNo = refNo;
    }
}

export class putAccountConfirmServiceResModel{
    error: boolean;
    message: string;

    constructor(error: boolean, message: string){
        this.error = error;
        this.message = message;
    }
}